/**
 * Show a toast message using window.ikea.toast if available, otherwise fallback.
 * @param {string} title - The title of the toast message.
 * @param {string} [message] - Optional body text shown below the title.
 * @param {import('@ingka-group-digital/window-ikea-typings/src/navigation/toast').ActionButton} [actionButton] - Optional action button.
 */
export function showToast(title, message, actionButton) {
  const content = message ? `<b>${title}</b><br/>${message}` : title;
  if (typeof window?.ikea?.toast === 'function') {
    window.ikea.toast(content, actionButton);
  } else {
    // eslint-disable-next-line no-console
    console.debug('Toast:', content, actionButton);
  }
}
